export enum ProductsEnum {
  profit = 'profit',
  cashFlow = 'cash-flow',
  register = 'register',
  dividends = 'dividends',
  tva = 'tva',
  margin = 'margin',
  generateStatement = 'generate-statement',
  // partners = 'partners',
  requests = 'requests',
  legacy = 'legacy',
}

export type ProductType = {
  icon: string;
  title: { first: string; second: string };
  desc: Array<string>;
};

export type ProductsDataType = Record<ProductsEnum, ProductType>;

// Tva Types

export type TvaType = {
  tva_amount: string
  cu_tva: boolean
}

// Dividends Types

export type DividendsType = Array<{
  id: string
  title: string
  name: string
  icon: string
  inputs: Array<DividendInputType>
}>

export type DividendInputType = {
  name: string
  value: string
  type: string
  placeholder: string
}